        <span *ngFor="let charPart of phraseDiffs" 
          class="match-diff" 
          [class.missing]="charPart.diffType == 'MISSING'"
          [class.extra]="charPart.diffType == 'EXTRA'"
          >{{ charPart.text }}</span>